<template>
  <div class="my_popup">
    <van-popup v-model="show" position="bottom" :lock-scroll="false" :close-on-click-overlay="false"
      :style="{ height: '100%' }" class="loginDialog" @closed="colseLogin">
      <div class="top-back"></div>
      <div class="title">
        <img src="../assets/home/logo.jpg" alt="" />
        <div class="message">
          <p class="paopao">泡泡云手机</p>
          <p>游戏托管神器 您的24小时挂机助手</p>
        </div>
      </div>
      <van-tabs v-model="active" @change="toggleLogin" style="width: 100%">
        <van-tab title="验证码登录">
          <div class="form">
            <van-form @submit="onSubmit">
              <van-field v-model="phone" name="phone" label="+86" type="tel" placeholder="请输入手机号码" maxlength="11"
                clearable @click="onScrollTOP" />
              <van-button class="get-code-button" :class="{ btnactive: phone.length == 11 }"
                :disabled="phone.length < 11" round block type="info" native-type="submit">获取验证码</van-button>
              <div class="xieyi">
                <van-checkbox style="overflow: inherit" v-model="loginchecked" shape="square" icon-size="0.5rem">
                  <template #icon="props">
                    <img class="img-icon" style="
                        width: 0.8rem;
                        margin-top: -0.1rem;
                        margin-right: 0.2rem;
                      " :src="props.checked
                          ? require('../assets/home/checked.png')
                          : require('../assets/home/nochecked.png')
                        " />
                  </template>
                  登录即同意
                  <span @click.stop="getProtocol(0)">《用户协议》</span>、
                  <span @click.stop="getProtocol(1)">《隐私政策》</span>
                  和
                  <span @click.stop="getDisclaimers">《平台免责声明》</span>
                </van-checkbox>
              </div>
              <div v-if="isApp" class="oneLogin" @click="oneLogin">
                <p>使用 <span>本机号码一键登录></span></p>
              </div>
            </van-form>
          </div>
          <div class="wx_login" v-if="isWeChatBrowser()">
            <div class="wx_title">
              <p class="wx_line"></p>
              <p class="wx_txt">其他登录</p>
              <p class="wx_line"></p>
            </div>
            <div class="wx_icon">
              <img class="wx_icon_img" src="../assets/origin/wx_icon.png" alt="" @click="loginWithWechat" />
            </div>
          </div>
        </van-tab>
        <van-tab title="密码登录">
          <div class="form">
            <van-form @submit="onCodeSubmit">
              <van-field v-model="telephone" name="phone" label="+86" type="tel" placeholder="请输入手机号码" maxlength="11"
                clearable @click="onScrollTOP" />
              <van-field class="codeInput" :class="{
                codeinputactive:
                  telephone.length == 11 && phoneCode.length >= 8,
              }" v-model="phoneCode" name="phoneCode" :type="inputType" placeholder="请输入密码" maxlength="15" clearable
                @focus="onScrollTOP" @click="onScrollTOP">
                <template #left-icon>
                  <div class="codebom" :class="{
                    'line-active':
                      telephone.length == 11 && phoneCode.length >= 8,
                  }">
                    <div class="eyes" @click="openEyes">
                      <img v-if="
                        (inputType == 'text' && phoneCode.length < 8) ||
                        (inputType == 'text' &&
                          phoneCode.length >= 8 &&
                          telephone.length < 11)
                      " src="../assets/home/eye1.png" alt="" />
                      <img v-if="
                        (inputType == 'password' && phoneCode.length < 8) ||
                        (inputType == 'password' &&
                          phoneCode.length >= 8 &&
                          telephone.length < 11)
                      " src="../assets/home/eye-white-s.png" alt="" />
                      <img v-if="
                        inputType == 'text' &&
                        telephone.length == 11 &&
                        phoneCode.length >= 8
                      " src="../assets/home/eye-grey1.png" alt="" />
                      <img v-if="
                        inputType == 'password' &&
                        telephone.length == 11 &&
                        phoneCode.length >= 8
                      " src="../assets/home/eye-shot1.png" alt="" />
                    </div>
                  </div>
                </template>
              </van-field>
              <div class="forget" :class="{
                'line-active':
                  telephone.length == 11 && phoneCode.length >= 8,
              }" @click="forgetPop">
                忘记密码?
              </div>
              <van-button class="get-code-button" :class="{
                logactive: telephone.length == 11 && phoneCode.length >= 8,
              }" :disabled="telephone.length < 11 || phoneCode.length < 8" round block type="info"
                native-type="submit">登录</van-button>
              <div class="xieyi">
                <van-checkbox style="overflow: inherit" v-model="loginchecked" shape="square" icon-size="0.5rem">
                  <template #icon="props">
                    <img class="img-icon" style="
                        width: 0.8rem;
                        margin-top: -0.1rem;
                        margin-right: 0.2rem;
                      " :src="props.checked
                          ? require('../assets/home/checked.png')
                          : require('../assets/home/nochecked.png')
                        " />
                  </template>
                  登录即同意
                  <span @click.stop="getProtocol(0)">《用户协议》</span>、
                  <span @click.stop="getProtocol(1)">《隐私政策》</span>
                  和
                  <span @click.stop="getDisclaimers">《平台免责声明》</span>
                </van-checkbox>
              </div>
              <div v-if="isApp" class="oneLogin" @click="oneLogin">
                <p>使用 <span>本机号码一键登录></span></p>
              </div>
            </van-form>
          </div>
        </van-tab>
      </van-tabs>
      <!-- 输入登录验证码 -->
      <van-popup @close="closeCode" class="code" position="bottom" v-model="showCode">
        <van-icon @click="showCode = false" name="arrow-left" size="1rem" style="margin-top: 1.9rem" />
        <p class="codetitle">
          {{ timer ? "已向" : "请向" }} {{ phoneNone(phone) }} 发送验证码
        </p>
        <!-- 验证码输入 -->
        <cell-input ref="cellInput" @inputValue="inputValue"></cell-input>
        <div class="sendCode">
          <van-button :disabled="timer" @click="sendPhoneCode" :class="{ codeactive: timer }">
            <van-count-down @finish="timer = false" v-if="timer" :time="60000" format=" ss 秒后重新发送" />
            <div v-else>重新获取验证码</div>
          </van-button>
        </div>
      </van-popup>
      <!-- 忘记密码 -->
      <van-popup class="forgetCode" position="bottom" v-model="showForgetCode">
        <van-nav-bar :class="{ top_nav_bar: true }" title="" left-arrow @click-right="closeCodePop"
          @click-left="closeCodePop">
          <template #right>
            <van-icon name="cross" size="18" />
          </template>
        </van-nav-bar>
        <div class="headline">忘记密码</div>
        <div class="title">
          <img src="../assets/home/logo.jpg" alt="" />
          <div class="message">
            <p class="paopao">泡泡云手机</p>
            <p>游戏托管神器 您的24小时挂机助手</p>
          </div>
        </div>
        <div class="form">
          <van-form @submit="onForCodeSubmit">
            <van-field v-model="forgetPhone" name="phone" label="+86" type="tel" placeholder="请输入手机号码" maxlength="11"
              clearable />
            <van-button :class="{ btnactive: forgetPhone.length == 11 }" :disabled="forgetPhone.length < 11" round block
              type="info" native-type="submit">获取验证码</van-button>
          </van-form>
        </div>
      </van-popup>
      <!-- 忘记密码验证码 -->
      <van-popup @close="closeCode" class="code" position="bottom" v-model="showModifyCode">
        <van-icon @click="closeInputCode" name="arrow-left" size="1rem" style="margin-top: 1.9rem" />
        <p class="codetitle">
          {{ timer ? "已向" : "请向" }} {{ phoneNone(forgetPhone) }} 发送验证码
        </p>
        <!-- 验证码输入 -->
        <cell-input ref="cellInput" @inputValue="inputForgetValue"></cell-input>
        <div class="sendCode">
          <van-button :disabled="timer" @click="sendForgetCode" :class="{ codeactive: timer }">
            <van-count-down @finish="timer = false" v-if="timer" :time="60000" format=" ss 秒后重新发送" />
            <div v-else>重新获取验证码</div>
          </van-button>
        </div>
      </van-popup>
      <!-- 设置新密码 -->
      <van-popup @close="closeCode" class="code newCode" position="bottom" v-model="showNewInput">
        <van-nav-bar :class="{ top_nav_bar: true }" title="" left-arrow @click-right="closeNewInput"
          @click-left="closeNewInput">
          <template #right>
            <van-icon name="cross" size="18" />
          </template>
        </van-nav-bar>
        <div class="headline">设置新密码</div>
        <p class="setTitle">请设置账号 {{ phoneNone(forgetPhone) }} 的密码</p>
        <p class="setTitleTips">密码为8-15位（不能全字母或数字）</p>
        <div class="form setForm">
          <van-form @submit="onSubmitCode">
            <van-field :class="{ focus: isFocus }" v-model="newCodeVal" name="newCodeVal" :type="codeType"
              placeholder="请输入密码" maxlength="15" clearable @focus="onFocus" @blur="onBlur">
              <template #button>
                <div class="codeEyes" @click="onCodeShow">
                  <img v-if="codeType == 'text'" src="../assets/home/eye-grey1.png" alt="" />
                  <img v-if="codeType == 'password'" src="../assets/home/eye-shot1.png" alt="" />
                </div>
              </template>
            </van-field>
            <van-field :class="{ elseFocus: isElseFocus }" v-model="reWriteCode" name="reWriteCode" :type="reCodeType"
              placeholder="请再次输入新密码" maxlength="15" clearable @focus="onElseFocus" @blur="onElseBlur">
              <template #button>
                <div class="codeEyes" @click="onReCodeShow">
                  <img v-if="reCodeType == 'text'" src="../assets/home/eye-grey1.png" alt="" />
                  <img v-if="reCodeType == 'password'" src="../assets/home/eye-shot1.png" alt="" />
                </div>
              </template>
            </van-field>
            <van-button :class="{
              reactive:
                newCodeVal.length >= 8 &&
                reWriteCode.length >= 8 &&
                newCodeVal.length == reWriteCode.length,
            }" block type="info" native-type="submit">确认</van-button>
          </van-form>
        </div>
      </van-popup>
      <!-- 绑定手机号 -->
      <van-popup class="forgetCode" position="bottom" v-model="bindPhonePop">
        <van-nav-bar :class="{ top_nav_bar: true }" title="" left-arrow @click-right="closeBindPop"
          @click-left="closeBindPop">
          <template #right>
            <van-icon name="cross" size="18" />
          </template>
        </van-nav-bar>
        <div class="headline">绑定手机号</div>
        <div class="title">
          <img src="../assets/home/logo.jpg" alt="" />
          <div class="message">
            <p class="paopao">泡泡云手机</p>
            <p>游戏托管神器 您的24小时挂机助手</p>
          </div>
        </div>
        <div class="form">
          <van-form @submit="onBindTelSubmit">
            <van-field v-model="bindPhone" name="phone" label="+86" type="tel" placeholder="请输入手机号码" maxlength="11"
              clearable />
            <van-button :class="{ btnactive: bindPhone.length == 11 }" :disabled="bindPhone.length < 11" round block
              type="info" native-type="submit">获取验证码</van-button>
          </van-form>
        </div>
      </van-popup>
      <!-- 绑定手机号验证码 -->
      <van-popup @close="closeCode" class="code" position="bottom" v-model="bindPhoneCode">
        <van-icon @click="closeBindCode" name="arrow-left" size="1rem" style="margin-top: 1.9rem" />
        <p class="codetitle">
          {{ timer ? "已向" : "请向" }} {{ phoneNone(bindPhone) }} 发送验证码
        </p>
        <!-- 验证码输入 -->
        <cell-input ref="cellInput" @inputValue="inputBind"></cell-input>
        <div class="sendCode">
          <van-button :disabled="timer" @click="onBindTelSubmit" :class="{ codeactive: timer }">
            <van-count-down @finish="timer = false" v-if="timer" :time="60000" format=" ss 秒后重新发送" />
            <div v-else>重新获取验证码</div>
          </van-button>
        </div>
      </van-popup>
    </van-popup>

    <!-- 用户协议政策 -->
    <van-popup class="protocol_c" v-model="showProtocol">
      <div>
        <van-icon @click="showProtocol = false" color="#333333" name="arrow-left" size="1rem"
          style="padding: 0.6rem 0.8rem; margin-top: 1rem; font-size: 1rem" />
      </div>

      <div class="bgc"></div>
      <div class="text">
        <!-- <h1>{{title}}</h1>
              <div class="content" v-html="content"></div> -->
        <iframe :src="content" frameborder="0"></iframe>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { Toast } from "vant";
export default {
  name: "YunFrontMyPopup",

  props: {
    onSuccess: Function,
    onError: Function,
    onClose: Function,
  },
  data() {
    return {
      active: 0,
      show: false, // 登录弹框
      phone: "",
      telephone: "",
      phoneCode: "",
      forgetPhone: "",
      newCodeVal: "",
      reWriteCode: "",
      showForgetCode: false,
      showModifyCode: false,
      showNewInput: false,
      loginchecked: false, // 协议选中
      showCode: false, //验证码弹框
      value: "", // 验证码
      showKeyboard: true,
      errorInfo: "",
      timer: true, // 倒计时
      showProtocol: false, // 用户协议
      protocolData: null,
      content: "",
      title: "",
      otimer: null,
      isFocus: false,
      isElseFocus: false,
      inputType: "password",
      codeType: "password",
      reCodeType: "password",
      wxOpenid: "",
      bindPhonePop: false,
      bindPhoneCode: false,
      bindPhone: "",
    };
  },

  computed: {
    isApp() {
      return JSON.parse(this.$store.state.isApp);
    },
    isPc() {
      return this.$store.getters.ua.isPc;
    },
    isiOS() {
      var u = navigator.userAgent;
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return true;
      } else {
        return false;
      }
    },
    isAndroid() {
      return this.$store.getters.ua.isAndroid;
    },
  },
  created() {
    if (this.isWeChatBrowser()) {
      this.wechatSubmit();
    }
  },
  mounted() {
    window.addEventListener("popstate", this.goBack, false);
    // console.log(this.isApp);
    this.show = true;
    this.$nextTick(() => {
      var input = document.querySelector("input");
      input.addEventListener("focus", (e) => {
        if (input.value == "请输入手机号码") {
          input.value = "";
        }
      });
    });
  },

  methods: {
    isWeChatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /micromessenger/.test(userAgent);
    },
    goBack() {
      this.showProtocol = false;
    },
    pushHistory(url = "#") {
      var state = {
        title: "title",
        url: url,
      };
      window.history.pushState(state, "title", "#");
    },
    colseLogin() {
      document
        .querySelector("body")
        .removeChild(document.querySelector(".my_popup"));
    },
    toggleLogin(name) {
      if (name == 1) {
        var yunName = Cookies.get("yunName");
        var yunCode = Cookies.get("yunCode");
        if (yunName && yunCode) {
          this.telephone = yunName;
          this.phoneCode = yunCode;
        }
      }
    },
    closeCode() {
      this.$refs.cellInput.closeCode();
    },
    forgetPop() {
      this.showForgetCode = true;
    },
    loginWithWechat() {
      if (!this.loginchecked) {
        this.$toast("请阅读并同意用户协议和隐私政策");
        return;
      }
      if (this.isWeChatBrowser()) {
        // let baseApi;
        // if (process.env.VUE_APP_API_URL == "http://api.yun.fgcq.info") {
        //   baseApi =
        //     "https://yunapi.paopaoysj.com/notify/transfer?is_transfer=1&transfer_type=1&&app_id=1";
        // } else {
        //   baseApi =
        //     "https://yunapi.paopaoysj.com/notify/wx-callback-transfer?is_transfer=1&transfer_type=1&&app_id=1";
        // }
        // 微信内置浏览器中使用oauth2/authorize
        const redirectUri = encodeURIComponent(
          "https://yunapi.paopaoysj.com/notify/wx-callback-transfer?is_transfer=1&transfer_type=1&&app_id=1"
        );
        const appId = "wx4213f4dd7ccf00e0";
        const scope = "snsapi_userinfo"; // 或者 'snsapi_base'
        const state = "STATE"; // 可以是任意字符串，用于防止CSRF攻击
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
        window.location.href = url;
      }
      // else {
      //   // 非微信内置浏览器中使用qrconnect
      //   const redirectUri = encodeURIComponent(
      //     `http://api.yun.fgcq.info/notify/wx-callback-transfer?is_transfer=2&transfer_type=2&&app_id=1`
      //   );
      //   const appId = "wx6792bd5db777e0be";
      //   const responseType = "code";
      //   const scope = "snsapi_login"; // 注意这里使用 snsapi_login
      //   const state = "STATE"; // 可以是任意字符串，用于防止CSRF攻击

      //   const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=${state}#wechat_redirect`;
      //   window.location.href = url;
      // }
    },
    wechatSubmit() {
      const loginParams = {};
      const search = window.location.search.substring(1);
      const params = search.split("&");
      params.forEach((param) => {
        const [key, value] = param.split("=");
        loginParams[key] = decodeURIComponent(value);
      });
      // console.log(loginParams);
      if (loginParams.wx_login_code) {
        this.$Ajax("login/wx-login", {
          code: loginParams.wx_login_code,
          wx_login_type: loginParams.wx_login_type,
          wx_login_id: loginParams.wx_login_id,
        }).then((rs) => {
          if (rs.code == 1) {
            if (rs.data.userId == "-1") {
              this.$toast("请绑定手机号");
              this.wxOpenid = rs.data.wx_openid;
              this.bindPhonePop = true;
            } else {
              this.$store.dispatch("setCookies", rs.data);
              this.$store.dispatch("getUserData", true);
              if (this.onSuccess) {
                this.onSuccess();
              }
              setTimeout(() => {
                this.showCode = false;
                this.show = false;
                Toast.success("登陆成功,欢迎使用");
              }, 0);
              try {
                window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(
                  JSON.stringify(rs.data)
                );
              } catch (error) {
                console.log(error);
              }
            }
          }
        });
      }
    },
    onBindTelSubmit() {
      // 绑定手机发送验证码
      this.$Ajax("index/send-phone-code", {
        phone: this.bindPhone,
        action: "wx_bind",
      }).then((rs) => {
        this.timer = true;
        if (rs.code == 1) {
          this.bindPhonePop = false;
          this.bindPhoneCode = true;
          this.$toast.success(rs.msg);
        } else {
          this.$toast(rs.msg);
        }
      });
    },
    closeBindPop() {
      this.bindPhonePop = false;
      this.bindPhone = "";
    },
    closeBindCode() {
      this.bindPhonePop = true;
      this.bindPhoneCode = false;
    },
    inputBind(e) {
      this.$Ajax("wxapi/wx-bind-phone", {
        phone: this.bindPhone,
        code: e,
        wx_openid: this.wxOpenid,
      }).then((rs) => {
        if (rs.code == 1) {
          this.$store.dispatch("setCookies", rs.data);
          this.$store.dispatch("getUserData", true);
          if (this.onSuccess) {
            this.onSuccess();
          }
          setTimeout(() => {
            this.showCode = false;
            this.show = false;
            Toast.success("登陆成功,欢迎使用");
          }, 0);
          try {
            window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(
              JSON.stringify(rs.data)
            );
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$toast(rs.msg);
        }
      });
    },
    // 忘记密码页面获取验证码
    onForCodeSubmit() {
      this.sendForgetCode();
    },
    sendForgetCode() {
      this.$Ajax("index/send-phone-code", {
        phone: this.forgetPhone,
        action: "password",
      }).then((rs) => {
        this.timer = true;
        if (rs.code == 1) {
          this.showForgetCode = false;
          this.showModifyCode = true;
          this.$toast.success(rs.msg);
        } else {
          this.$toast(rs.msg);
        }
      });
    },
    inputForgetValue(e) {
      this.$Ajax("login/password-code", {
        phone: this.forgetPhone,
        code: e,
      }).then((rs) => {
        if (rs.code == 1) {
          this.showModifyCode = false;
          this.showNewInput = true;
        } else {
          this.$toast(rs.msg);
        }
      });
    },
    onCodeShow() {
      this.codeType = this.codeType === "text" ? "password" : "text";
    },
    onReCodeShow() {
      this.reCodeType = this.reCodeType === "text" ? "password" : "text";
    },
    closeCodePop() {
      this.showForgetCode = false;
      this.forgetPhone = "";
    },
    closeInputCode() {
      this.showForgetCode = true;
      this.showModifyCode = false;
    },
    closeNewInput() {
      this.showForgetCode = true;
      this.showNewInput = false;
      this.newCodeVal = "";
      this.reWriteCode = "";
    },
    onFocus() {
      this.isFocus = true;
    },
    onBlur() {
      this.isFocus = false;
    },
    onElseFocus() {
      this.isElseFocus = true;
    },
    onElseBlur() {
      this.isElseFocus = false;
    },
    // 提交新密码
    onSubmitCode() {
      if (!this.newCodeVal.length || !this.reWriteCode.length) {
        this.$toast("请输入密码");
        return;
      }
      if (
        this.newCodeVal.length < 8 ||
        this.newCodeVal.length > 15 ||
        this.reWriteCode.length < 8 ||
        this.reWriteCode.length > 15
      ) {
        this.$toast("密码为8-15位");
        return;
      }
      if (this.newCodeVal != this.reWriteCode) {
        this.$toast("您两次输入的密码不一致");
        return;
      }
      if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]*$/.test(this.newCodeVal)) {
        this.$toast("不能全是字母或数字");
        return;
      }
      // 更改新密码逻辑
      this.$Ajax("user/setting-pass", {
        phone: this.forgetPhone,
        new_password: this.newCodeVal,
        password: this.reWriteCode,
      }).then((rs) => {
        if (rs.code == 1) {
          this.$toast("重置密码成功");
          setTimeout(() => {
            this.newCodeVal = this.reWriteCode = "";
            this.showNewInput = false;
          }, 1000);
        } else {
          this.$toast(rs.msg);
        }
      });
    },
    // 验证码输入完成
    inputValue(e) {
      var obj = {
        phone: this.phone,
        code: e,
      };
      this.$Ajax("login/phone-code-login", obj).then((rs) => {
        if (rs.code == 1) {
          const isNewCustomer = rs.data.isNewCustomer;
          sessionStorage.setItem("isNewRegister", isNewCustomer);
          this.$store.dispatch("setCookies", rs.data);
          this.$store.dispatch("getUserData", true);
          if (this.onSuccess) {
            this.onSuccess();
          }
          setTimeout(() => {
            this.showCode = false;
            this.show = false;
            if (isNewCustomer == 1) {
              this.$router.replace({ name: "user.setpassword" });
            } else {
              Toast.success("登陆成功,欢迎使用");
            }
          }, 0);
          try {
            window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(
              JSON.stringify(rs.data)
            );
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$toast(rs.msg);
          this.closeCode();
        }
      });
    },
    oneLogin() {
      if (this.otimer != null) return;
      this.$store.commit("isOneLogin", 1);
      try {
        // web端通知原生端拉起运营商登录
        window.webkit.messageHandlers.openPnsLoginWebToNative.postMessage("xx");
      } catch (error) {
        console.log(error);
      }
      this.otimer = setTimeout(() => {
        this.otimer = null;
      }, 1000);
    },
    onScrollTOP() {
      const container = document.querySelector(".loginDialog");
      setTimeout(() => {
        container.scrollTop = window.innerHeight;
      }, 400);
    },
    onSubmit() {
      if (!this.phoneZe(this.phone)) {
        Toast.fail("手机号码格式不正确");
        return;
      }
      if (!this.loginchecked) {
        Toast.fail("请勾选同意后再操作");
        return;
      }
      this.showCode = true;
      this.sendPhoneCode();
    },
    openEyes() {
      this.inputType = this.inputType === "text" ? "password" : "text";
    },
    onCodeSubmit() {
      if (!this.phoneZe(this.telephone)) {
        Toast.fail("手机号码格式不正确");
        return;
      }
      if (!this.loginchecked) {
        Toast.fail("请勾选同意后再操作");
        return;
      }
      this.$Ajax("login/password-login", {
        phone: this.telephone,
        password: this.phoneCode,
      }).then((rs) => {
        if (rs.code == 1) {
          let expires = new Date();
          expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 24 小时后的时间
          Cookies.set("yunName", this.telephone, { expires: expires });
          Cookies.set("yunCode", this.phoneCode, { expires: expires });

          this.$store.dispatch("setCookies", rs.data);
          this.$store.dispatch("getUserData", true);

          if (this.onSuccess) {
            this.onSuccess();
          }
          setTimeout(() => {
            this.showCode = false;
            this.show = false;
            Toast.success("登陆成功,欢迎使用");
          }, 0);
          try {
            window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(
              JSON.stringify(rs.data)
            );
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$toast(rs.msg);
        }
      });
    },
    sendPhoneCode() {
      this.$Ajax("index/send-phone-code", {
        phone: this.phone,
        action: "login",
      }).then((rs) => {
        this.timer = true;
        if (rs.code == 1) {
          Toast.success(rs.msg);
        } else {
          Toast(rs.msg);
        }
      });
    },
    phoneZe(phone) {
      return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone);
    },
    phoneNone(val) {
      val = "" + val;
      var newVal = val.substr(0, 3) + "****" + val.substr(7);
      return newVal;
    },
    // 用户协议
    getProtocol(a) {
      this.content = "";
      if (a == 0) {
        this.title = "用户协议";
      } else {
        this.title = "隐私政策";
      }
      this.$Ajax("index/get-protocol", {
        protocolType: a == 0 ? "protocol" : "policy",
      }).then((rs) => {
        this.showProtocol = true;
        if (rs.code == 1) {
          this.protocolData = rs.data;
          this.content = this.protocolData.link;
        }
      });
    },
    getDisclaimers() {
      this.content = "";
      this.showProtocol = true;
      this.content = "https://yunapionline.cgodjk.com/Uploads/disclaimers.html";
    },
  },

  watch: {
    phone: {
      handler(a) {
        if (!/^[1-9][0-9]*$/.test(a)) {
          this.phone = a.replace(/\D/g, "");
        }
      },
    },
    telephone: {
      handler(a) {
        if (!/^[1-9][0-9]*$/.test(a)) {
          this.telephone = a.replace(/\D/g, "");
        }
      },
    },
    forgetPhone: {
      handler(a) {
        if (!/^[1-9][0-9]*$/.test(a)) {
          this.forgetPhone = a.replace(/\D/g, "");
        }
      },
    },
    phoneCode: {
      handler(a) {
        if (!/^[a-zA-Z0-9]+$/.test(a)) {
          this.phoneCode = a.replace(/[^a-zA-Z\d]/g, "");
        }
      },
    },
    newCodeVal: {
      handler(a) {
        if (!/^[a-zA-Z0-9]+$/.test(a)) {
          this.newCodeVal = a.replace(/[^a-zA-Z\d]/g, "");
        }
      },
    },
    reWriteCode: {
      handler(a) {
        if (!/^[a-zA-Z0-9]+$/.test(a)) {
          this.reWriteCode = a.replace(/[^a-zA-Z\d]/g, "");
        }
      },
    },
    show: {
      handler(a) {
        if (!a) {
          if (location.href.includes("#")) {
            history.back();
          }
        }
      },
    },
    showProtocol: {
      immediate: true,
      handler(a) {
        if (a) {
          this.pushHistory();
        } else {
          if (location.href.includes("#")) {
            history.back();
          }
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.my_popup {
  max-width: 600px !important;
  margin: 0 auto !important;
  z-index: 9999;

  :deep(.van-overlay) {
    z-index: 2023 !important;
  }

  .loginDialog {
    overflow: auto;
    height: 100%;
    z-index: 2050 !important;
    // border-radius: .4rem .4rem 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 600px;
    left: auto;

    .top-back {
      height: 10.5rem;
      width: 100%;
      background: url("../assets/home/loginBg.png") no-repeat top;
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }

    .title {
      margin-top: 5.8rem;
      margin-bottom: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 3.25rem;

      img {
        width: 2.9rem;
        height: 2.9rem;
      }

      .message {
        margin-left: 0.4rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          color: #5d5d5d;

          &:nth-child(1) {
            font-size: 1rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 0.3rem;
          }
        }
      }
    }

    :deep(.van-tabs--line) {
      position: absolute;
      top: 10.45rem;
      background-color: #ffffff;
      border-radius: 1.25rem 1.25rem 0 0;
      border-top: 0.05rem solid #f0e4ff;
      padding-top: 1rem;
      flex: 1;
    }

    :deep(.van-tabs__nav--line) {
      width: 62%;
      margin-left: 0.7rem;

      .van-tab {
        font-size: 0.8rem;
        font-weight: bold;
        color: #5d5d5d;
      }

      .van-tab--active {
        font-weight: bold;
        color: #6714cc;
      }

      .van-tabs__line {
        background: #5d5d5d;
      }
    }

    .form {
      margin-top: 2.05rem;

      /deep/.van-cell {
        width: 15rem;
        height: 2.5rem;
        border-radius: 1.25rem;
        line-height: 1.4rem;
        padding: 0.5rem 0.8rem 0.5rem 1.5rem;

        &:nth-child(1) {
          background-image: linear-gradient(to right, #286ff8, #6714cc);
          font-size: 0.8rem;
        }

        .van-field__label {
          color: #fff;
          font-size: 0.8rem;
          width: 2.5em;
          margin-right: 2.5em;
          border-right: 1px solid #fff;
          height: 0.7rem;
          margin-top: 0.3rem;

          span {
            position: absolute;
            top: 0.5rem;
          }
        }

        .van-field__control {
          color: #fff;

          &::placeholder {
            color: #fff;
          }

          z-index: 1;
          margin-right: 1.5rem;
        }

        /deep/.van-field__clear {
          z-index: 999;
        }
      }

      .codeInput {
        align-items: center;
        margin-top: 1.25rem !important;
        background: #b4b4b4;
        font-size: 0.8rem;

        /deep/.van-field__left-icon {
          margin-right: 0;

          .codebom {
            width: 2.5em;
            height: 0.7rem;
            margin-right: 2.5em;
            border-right: 1px solid #fff;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .eyes {
              width: 0.85rem;
              height: 0.65rem;

              img {
                width: 100%;
                margin-bottom: 0.25rem;
              }
            }
          }

          .line-active {
            border-right: 1px solid #5d5d5d;
          }
        }

        /deep/.van-field__body {
          .van-field__button {
            padding-left: 0;
          }

          .van-field__control {
            color: #000000;
          }

          .van-icon-clear {
            color: #ffffff;
          }
        }
      }

      .van-field {
        margin: 0 auto;
      }

      .van-button {
        width: 15rem;
        height: 2.5rem;
        margin: 0 auto;
        border-radius: 1.25rem;
        background-color: #b4b4b4;
        opacity: 1;
        border: 0;
        margin-top: 2.35rem;
        font-size: 0.8rem;
      }

      .forget {
        color: #6714cc;
        font-size: 0.6rem;
        padding-right: 0.5rem;
        line-height: 15px;
        width: 15rem;
        margin: 0.35rem auto 0;
        text-align: right;
      }

      .get-code-button {
        margin-top: 1.25rem;
      }

      .btnactive {
        background-color: #f0e4ff;
        color: #000000;
      }

      /deep/.codeinputactive {
        color: #000000;
        background: #f0e4ff;

        .van-icon-clear {
          color: #827f85 !important;
        }
      }

      .logactive {
        background: #9136ff;
        color: #ffffff;
      }

      .xieyi {
        width: 15rem;
        line-height: 1rem;
        margin: 0.9rem auto 0;
        font-size: 0.6rem;

        /deep/.van-checkbox {
          align-items: flex-start;

          .van-checkbox__icon--square {
            margin-top: 0.15rem;
          }

          .van-checkbox__label {
            color: #707070;
            font-size: 0.6rem;
          }

          .van-checkbox__icon--checked .van-icon {
            background-color: transparent;
            border-color: #707070;
            color: #000;
            line-height: 1.1;
          }

          .van-checkbox__icon .van-icon {
            border-radius: 0.1rem;
          }
        }

        span {
          color: #286ff8;
          font-size: 0.6rem;
        }
      }

      .oneLogin {
        margin-top: 3.3rem;
        font-size: 12px;
        text-align: center;

        span {
          color: #6714cc;
        }
      }
    }

    .wx_login {
      width: 15rem;
      margin: 1.5rem auto;

      .wx_title {
        display: flex;
        align-items: center;

        .wx_txt {
          width: max-content;
          color: #707070;
          font-size: 0.6rem;
          flex-shrink: 0;
          padding: 0 0.8rem;
        }

        .wx_line {
          width: 100%;
          height: 0.05rem;
          background: #cfcfcf;
        }
      }

      .wx_icon {
        display: flex;
        justify-content: center;
        margin-top: 0.65rem;

        .wx_icon_img {
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }

    .code {
      width: 100vw;
      height: 100vh;
      padding: 1.35rem 0.75rem;
      max-width: 600px;
      left: auto;
      z-index: 2050 !important;

      .codetitle {
        margin-top: 7.4rem;
        font-size: 0.8rem;
        color: #626566;
        text-align: center;
      }

      .inputCode {
        margin-top: 1.25rem;

        .van-password-input__item {
          background-color: #e4e4e4;
          width: 2.1rem;
          height: 2.45rem;
          border-radius: 0.15rem;
        }

        .van-password-input__item--focus {
          background-color: #b4b4b4;
        }
      }

      .sendCode {
        margin-top: 1.25rem;
        display: flex;
        justify-content: center;

        .van-button {
          width: 15rem;
          height: 2.5rem;
          background-image: linear-gradient(to right, #286ff8, #6714cc);
          border-radius: 1.25rem;
          color: #fff;

          .van-count-down {
            color: #fff;
          }
        }

        .codeactive {
          opacity: 60%;
        }
      }
    }

    .newCode {
      .van-hairline--bottom {
        margin-top: 2.5rem;
      }

      .van-hairline--bottom::after {
        border-bottom-width: 0;
      }

      .headline {
        margin-left: 0.8rem;
        margin-top: 4.5rem;
        font-size: 1.2rem;
        font-weight: bold;
        color: #000000;
      }

      .setTitle {
        margin-top: 1.85rem;
        margin-left: 1.75rem;
        font-size: 0.8rem;
        color: #626566;
      }

      .setTitleTips {
        margin-top: 0.5rem;
        margin-left: 1.75rem;
        font-size: 0.6rem;
        color: #ababab;
      }

      .setForm {
        margin-top: 2.05rem;

        /deep/.van-cell {
          width: 14rem;
          font-size: 0.8rem;
          padding: 0.5rem 0.6rem;
          background-image: none !important;
          margin-bottom: 1.5rem;
          border-radius: 0;
          border-bottom: 0.05rem #626566 solid;

          &:nth-child(2) {
            margin-bottom: 0.5rem;
          }

          .van-field__control {
            color: #000;

            &::placeholder {
              color: #ababab;
            }
          }

          .van-field__button {
            padding-left: 0.75rem;
          }

          .codeEyes {
            margin-bottom: 0.5rem;
            width: 0.85rem;
            height: 0.65rem;

            img {
              width: 100%;
            }
          }
        }

        .focus {
          border-bottom: 0.05rem #6714cc solid;
        }

        .elseFocus {
          border-bottom: 0.05rem #6714cc solid;
        }

        .reactive {
          background: linear-gradient(270deg, #6714cc 0%, #286ff8 100%);
        }
      }
    }

    .van-icon-cross {
      color: #000 !important;
    }

    .forgetCode {
      width: 100vw;
      height: 100vh;
      padding: 1.35rem 0.75rem;
      max-width: 600px;
      left: auto;
      z-index: 2050 !important;

      .van-hairline--bottom {
        margin-top: 2.5rem;
      }

      .van-hairline--bottom::after {
        border-bottom-width: 0;
      }

      .headline {
        margin-left: 0.8rem;
        margin-top: 4.5rem;
        font-size: 1.2rem;
        font-weight: bold;
        color: #000000;
      }

      .title {
        margin-top: 1.8rem;
        margin-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 3.25rem;

        img {
          width: 2.9rem;
          height: 2.9rem;
        }

        .message {
          margin-left: 0.4rem;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          p {
            color: #5d5d5d;

            &:nth-child(1) {
              font-size: 1rem;
              font-weight: 700;
              color: #000;
              margin-bottom: 0.3rem;
            }
          }
        }
      }

      .form {
        // width: 15rem;
        margin-top: 1.6rem;

        /deep/.van-cell {
          width: 15rem;
          height: 2.5rem;
          border-radius: 1.25rem;
          line-height: 1.4rem;
          padding: 0.5rem 1.5rem;

          &:nth-child(1) {
            background-image: linear-gradient(to right, #286ff8, #6714cc);
            font-size: 0.8rem;
          }

          .van-field__label {
            color: #fff;
            font-size: 0.8rem;
            width: 2.5em;
            margin-right: 2.5em;
            border-right: 1px solid #fff;
            height: 0.7rem;
            margin-top: 0.3rem;

            span {
              position: absolute;
              top: 0.5rem;
            }
          }

          .van-field__control {
            color: #fff;

            &::placeholder {
              color: #fff;
            }

            z-index: 1;
            margin-right: 1.5rem;
          }

          /deep/.van-field__clear {
            z-index: 999;
          }
        }

        .van-field {
          margin: 0 auto;
        }

        .van-button {
          width: 15rem;
          height: 2.5rem;
          margin: 0 auto;
          border-radius: 1.25rem;
          background-color: #b4b4b4;
          opacity: 1;
          border: 0;
          margin-top: 1.25rem;
          font-size: 0.8rem;
        }

        .btnactive {
          background-color: #f0e4ff;
          color: #000000;
        }
      }
    }
  }

  .protocol_c {
    z-index: 3050 !important;
    width: 100vw;
    height: 100vh;
    background-color: #f9f9f9;
    max-width: 600px;

    .bgc {
      width: 100%;
      height: 3.25rem;
      background-color: #cdb7e7;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }

    .text {
      iframe {
        width: 100%;
        // background: linear-gradient(
        //   180deg,
        //   rgba(205, 183, 231, 1) 0%,
        //   rgba(249, 249, 249, 0.1) 35%
        // );
        background: #f0f0f0;
        min-height: calc(var(--vh, 1) * 100 - 3.4rem);
      }

      h1 {
        font-size: 1.2rem;
      }

      .content {
        margin-top: 1.4rem;
      }
    }
  }
}

/deep/.van-cell::after {
  border: 0 !important;
}
</style>
